<template>
  <div class="filter-parent">
    <div class="filter-parent__header" @click.prevent="toggleItem">
      <svg v-if="icon" class="filter-parent__header-icon icon">
        <use :href="'#' + icon" />
      </svg>
      <h3 :id="ariaLabelId" v-text="title" />
      <button
        class="filter-parent__header-action btn link icon-right"
        :class="{ 'is-open': isOpen }"
      >
        {{ expandText }}
        <svg class="icon"><use :href="expandIcon" /></svg>
      </button>
    </div>
    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-if="isOpen" :ref="'content'" class="filter-parent__content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    ariaLabelId: {
      type: String,
      default: '',
    },
    title: {
      required: true,
      type: String,
    },
    startOpen: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isOpen: this.startOpen,
      texts: window.theme_vars.counselorGridTexts,
    };
  },

  computed: {
    expandIcon(): string {
      return this.isOpen ? '#minus' : '#plus';
    },

    expandText(): string {
      return this.isOpen ? this.texts.minimize : this.texts.expand;
    },
  },

  mounted() {
    if (this.startOpen) {
      (this.$refs.content as HTMLElement).style.maxHeight = 'none';
      (this.$refs.content as HTMLElement).style.overflow = 'visible';
    }
  },

  methods: {
    toggleItem(): void {
      this.isOpen = !this.isOpen;
    },

    beforeEnter(el: HTMLElement): void {
      el.style.maxHeight = '0';
      el.style.overflow = 'hidden';
    },

    enter(el: HTMLElement): void {
      el.style.maxHeight = el.scrollHeight + 'px';

      // Wait for the transition to finish before setting overflow to visible
      el.addEventListener(
        'transitionend',
        () => {
          el.style.maxHeight = 'none';
          el.style.overflow = 'visible';
        },
        { once: true }
      );
    },

    beforeLeave(el: HTMLElement): void {
      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.overflow = 'hidden';
    },

    leave(el: HTMLElement): void {
      el.style.maxHeight = '0';
    },
  },
});
</script>
